import React, { useState } from 'react';
import { Settings } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from './Dialog';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './Tabs';
import { Button } from './Button';
import { Tooltip, TooltipTrigger, TooltipContent } from './Tooltip';
import { UserSettingsAiForm } from './UserSettingsAiForm';
import { UserSettingsIntegrations } from './UserSettingsIntegrations';
import { UserSettingsProfileForm } from './UserSettingsProfileForm';
import { UserSettingsSecurityForm } from './UserSettingsSecurityForm';
import { UserSettingsPersonasTab } from './UserSettingsPersonasTab';
import { ThemesPanel } from './ThemesPanel';
import styles from './UserSettingsDialog.module.css';

export const UserSettingsDialog = () => {
  const [open, setOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('profile');

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <Tooltip>
        <TooltipTrigger asChild>
          <DialogTrigger asChild>
            <Button
              variant="ghost"
              size="icon-md"
              aria-label="Account Settings"
              className={styles.triggerButton}
            >
              <Settings className={styles.icon} />
            </Button>
          </DialogTrigger>
        </TooltipTrigger>
        <TooltipContent>Settings</TooltipContent>
      </Tooltip>
      <DialogContent className={styles.dialogContent}>
        <DialogHeader className={styles.dialogHeader}>
          <DialogTitle>Account Settings</DialogTitle>
        </DialogHeader>

        <Tabs value={activeTab} onValueChange={setActiveTab} className={styles.tabs}>
          <TabsList className={styles.tabsList}>
            <TabsTrigger value="profile">Profile</TabsTrigger>
            <TabsTrigger value="security">Security</TabsTrigger>
            <TabsTrigger value="ai">AI Configuration</TabsTrigger>
            <TabsTrigger value="personas">Personas</TabsTrigger>
            <TabsTrigger value="themes">Themes</TabsTrigger>
            <TabsTrigger value="integrations">Integrations</TabsTrigger>
          </TabsList>

          <div className={styles.tabContentWrapper}>
            <TabsContent value="profile" className={styles.tabContent}>
              <div className={styles.scrollableContent}>
                <UserSettingsProfileForm />
              </div>
            </TabsContent>
            <TabsContent value="security" className={styles.tabContent}>
              <div className={styles.scrollableContent}>
                <UserSettingsSecurityForm />
              </div>
            </TabsContent>
            <TabsContent value="ai" className={styles.tabContent}>
              <UserSettingsAiForm onCancel={() => setOpen(false)} enabled={open && activeTab === 'ai'} />
            </TabsContent>
            <TabsContent value="personas" className={styles.tabContent}>
              <div className={styles.scrollableContent}>
                <UserSettingsPersonasTab />
              </div>
            </TabsContent>
            <TabsContent value="themes" className={styles.tabContent}>
              <div className={styles.scrollableContent}>
                {activeTab === 'themes' && <ThemesPanel sessionId="__global__" isOwner hideProjectScope />}
              </div>
            </TabsContent>
            <TabsContent value="integrations" className={styles.tabContent}>
              <div className={styles.scrollableContent}>
                <UserSettingsIntegrations />
              </div>
            </TabsContent>
          </div>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};
